class Unauthenticated extends Error {
  constructor(message) {
    super(message);
    this.name = 'FunkeUnauthenticated';
  }
}
export default Unauthenticated;
